export const MESSAGES = {
  DAYS: 'nights',
  MIN_BOOKING: 'This villa has a minimum stay of',
  MIN_BOOKING_PART2: ", but if you need some flexibility with dates we're here to find a solution - just get in touch.",
  MAX_BOOKING: 'Villas have a maximum booking of',
  NON_BOOKABLE: 'Check in / Check out needs to be on Monday, Saturday, or Sunday',
  INVALID: 'Some or all of the dates selected are not available. Please select a different date range.',
  // BEFORE_START_DATE: 'This date is before your selected start date. Click to select a new start date.',
  // BEFORE_START_DATE_NON_BOOKABLE: 'This date is before your selected start date.',
  CONTACT_US: 'This day may be availble but can not be booked online, however you can send us a booking enquiry or contact us by phone to book these dates.',
};
